import { UrlSegment } from "@angular/router";

export function encodeUrlSegment(value: Array<UrlSegment>): string {
  const strUrl = value.toString();
  const encodeRegex = new RegExp('\'', 'g');
  const formatRegex = new RegExp(',', 'g');

  return strUrl.replace(encodeRegex, '%27').replace(formatRegex, '/');
}
